import { GlobalToken } from 'antd';
import { createGlobalStyle, DefaultTheme } from 'styled-components';
import './fonts.css';

const GlobalStyles = createGlobalStyle<{ theme: DefaultTheme }>`
  body {
    background-color: ${({ theme: { token } }: { theme: { token: GlobalToken } }) => token.colorBgLayout};
    color: ${({ theme: { token } }: { theme: { token: GlobalToken } }) => token.colorText};
    font-family: 'Heebo', sans-serif;
  }
  
  html,
  body {
    height: 100%;
    overflow: hidden;
  }
  
  #root {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: auto;
  }
  
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${({ theme: { token } }) => token.colorText};
  }
  
  a {
    color: ${({ theme: { token } }) => token.colorPrimary};
  
    &:visited,
    &:hover,
    &:active,
    &:focus {
      color: ${({ theme: { token } }) => token.colorPrimary};
    }
  
    text-decoration: none;
  }
  
  hr {
    height: 1px;
    border: none;
    margin: ${({ theme: { token } }) => token.marginMD}px 0;
    background-color: ${({ theme: { token } }) => token.colorBorder};
  }

  p,
  ul,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
  }

  ul {
    list-style-type: none;
    padding-left: 0;
  }
  
  * {
    &::-webkit-scrollbar {
      width: 14px;
      height: 18px;
    }
  
    &::-webkit-scrollbar-thumb {
      height: 6px;
      border: 4px solid rgba(0, 0, 0, 0);
      background-clip: padding-box;
      -webkit-border-radius: 7px;
      background-color: ${({ theme: { token } }) => token.colorBorder};
      -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
    }
  
    &::-webkit-scrollbar-button {
      width: 0;
      height: 0;
      display: none;
    }
  
    &::-webkit-scrollbar-corner {
      background-color: transparent;
    }
  }

  @media (max-width: 767px) {
    .ant-modal {
      max-width: unset;
    }
  }

  .relative {
    position: relative;
  }

  .bold {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }

  .bold-500 {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }

  .uppercase {
    text-transform: uppercase;
  }

  .noscroll {
    overflow: hidden;
  }

  .noscroll-y {
    overflow-y: hidden;
  }

  .noscroll-x {
    overflow-x: hidden;
  }

  .hidden {
    visibility: hidden;
  }

  .ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .beggining-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    direction: rtl;
    text-align: left;

      .station-name-option {
          direction: ltr;
          unicode-bidi: embed;
      }
  }

  .text-center {
    text-align: center;
  }

  .text-left {
    text-align: left;
  }

  .grid-area-4 {
    display: grid;
    grid-template-columns: minmax(100px, 200px) minmax(100px, 200px) minmax(100px, 200px) minmax(100px, 200px);
    grid-auto-rows: auto;
    column-gap: 10px;
    row-gap: 30px;
  }

  .grid-area-5 {
    display: grid;
    grid-template-columns: minmax(100px, 180px) minmax(100px, 180px) minmax(100px, 180px) minmax(100px, 180px) minmax(
        100px,
        180px
      );
    grid-auto-rows: auto;
    column-gap: 10px;
    row-gap: 30px;
    margin: ${({ theme: { token } }) => token.marginXXL}px 0 ${({ theme: { token } }) => token.marginSM}px 0;
    width: 100%;
  }

  .min0 {
    min-width: 0;
  }

  .capitalize {
    text-transform: capitalize;
  }

  .bright-sky-blue {
    color: ${({ theme: { token } }) => token.colorPrimary};
  }

  .mustard {
    color: ${({ theme: { token } }) => token.colorWarning};
  }

  .purply {
    color: ${({ theme: { token } }) => token.geekblue7};
  }

  .flex {
    display: flex;
  }

  .align-center {
    align-items: center;
  }

  .align-end {
    align-items: flex-end;
  }

  .justify-between {
    justify-content: space-between;
  }

  .display-none {
    display: none;
  }

  .capitalize-first-letter {
    &:first-letter {
      text-transform: capitalize;
    }
  }

  .inline-block {
    display: inline-block;
  }

  .subtitle-caps {
    color: ${({ theme: { token } }) => token.colorTextTertiary};
    text-transform: uppercase;
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }

  .flex-row-center {
    display: flex;
    flex-direction: row;
    align-items: center;
    align-content: center;
  }

  .flex-column-center {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;
  }

  svg {
    display: block; //Used to remove an auto-generated bottom-margin using svg.
  }

  .ant-message-notice-content {
    background: ${({ theme: { token } }) => token.colorBgElevated} !important;
    color: ${({ theme: { token } }) => token.colorText};
  }

  .validation-error-indicator {
    border: 2px solid ${({ theme: { token } }) => token.colorError} !important;
    border-radius: 4px;
    box-shadow: 0 0 0 2px ${({ theme: { token } }) => token.colorError}20;
  }

`;

export default GlobalStyles;
